import { differenceInYears } from 'date-fns';

/**
 * 計算年齡
 * @param {Date} birthday - 生日
 * @param {Date} [now] - 現在時間
 * @return {?number} 非正整數返回 null
 *
 * @example
 * // 假設現在為 2019-04-24
 * getAge(new Date('1995-09-04'));
 * //=> 19
 *
 * @example
 * // 指定現在時間
 * getAge(new Date('1995-09-04'), new Date('1997-09-05'));
 * //=> 2
 */
function getAge(birthday, now = new Date()) {
  if (!(birthday instanceof Date) || !(now instanceof Date)) return null;

  const age = differenceInYears(now, birthday);

  if (!Number.isInteger(age) || age < 0) return null;
  return age;
}

export default getAge;
